import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import gundi_not_found from "../../images/gundi_no_results_green.png";

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        // mt-[3px]: the app shell's pt-[115px] leaves 29px below the 86px nav;
        // design spec asks for a 32px gap between the nav and this card.
        <div
            data-testid="NotFoundPage-container"
            className="max-w-list-table mx-auto mt-[3px] bg-light-gray-button rounded-lg p-8 flex flex-row items-start gap-6"
        >
            <img src={gundi_not_found} alt="" className="h-[120px] shrink-0" />
            <div>
                <h1 className="text-2xl font-normal text-grey-g0 mb-1">
                    {t("404: Page not found")}
                </h1>
                <p className="text-base font-normal text-secondary-text mb-4">
                    {t("The page you are looking for doesn't exist, has been temporarily disabled, or was relocated.")}
                </p>
                <button
                    type="button"
                    data-testid="NotFoundPage-button"
                    className="flex h-9 px-3 py-2 justify-center items-center bg-white text-dark-green text-base font-semibold rounded hover:bg-neutral-gray-50 transition-colors duration-300"
                    onClick={() => navigate("/", { replace: true })}
                >
                    {t("Go to Connections Overview")}
                </button>
            </div>
        </div>
    );
};

export default NotFoundPage;
